import { noOp } from 'constants/helper';

import { CREATE_INITIATIVE_PANEL_CLOSE, CREATE_INITIATIVE_PANEL_OPEN } from 'actions/actionTypes';

const initialState = {
  isOpen: false,
  onClose: noOp,
  onCancel: noOp,
  onSave: noOp,
  selectedTimeBoundPeriod: null,
  baseKR: {},
  ownerEmployee: null,
  subObjective: null,
  actionDispatchSource: '',
  panelHeaderText: 'Add goal',
  team: null,
};

const createInitiativePanelReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_INITIATIVE_PANEL_OPEN: {
      const {
        onClose,
        onCancel,
        onSave,
        selectedTimeBoundPeriod,
        baseKR,
        ownerEmployee,
        team,
        subObjective,
        actionDispatchSource,
        panelHeaderText,
      } = action.payload;

      return {
        isOpen: true,
        onClose,
        onCancel,
        onSave,
        selectedTimeBoundPeriod,
        baseKR,
        ownerEmployee,
        subObjective,
        actionDispatchSource,
        panelHeaderText,
        team,
      };
    }

    case CREATE_INITIATIVE_PANEL_CLOSE: {
      return initialState;
    }

    default:
      return state;
  }
};

export default createInitiativePanelReducer;
